export const corePdpLink = (slug: string, addressToken: string) =>
  `/properties/${encodeURIComponent(slug)}/aid_${addressToken}`;

export const getShareableLink = (slug: string, addressToken: string) =>
  `www.opendoor.com${corePdpLink(slug, addressToken)}`;
